import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuprincipalComponent } from './menuprincipal/menuprincipal.component';
import { OrdenservicioModule } from './ordenservicio/ordenservicio.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./alojamiento/alojamiento.module').then(m => m.AlojamientoModule),
    data: {
        preload: true
    }
  },
  {
    path: 'alojamiento',
    loadChildren: () => import('./alojamiento/alojamiento.module').then(m => m.AlojamientoModule),
    data: {
        preload: true
    }
  },
  {
    path: 'ordenservicio',
    loadChildren: () => import('./ordenservicio/ordenservicio.module').then(m => m.OrdenservicioModule),
    data: {
        preload: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
